import React from 'react';
import type { DefaultSegmentTemplate } from '../default-segment-templates';
import { DialogHeader } from './DialogHeader';
import { TemplateList } from './TemplateList';

interface BaseSegmentTemplateSelectionProps {
  templates: DefaultSegmentTemplate[];
  onSelectTemplate: (templateName: string) => void;
  onClose: () => void;
}

export const BaseSegmentTemplateSelection: React.FC<
  BaseSegmentTemplateSelectionProps
> = ({ templates, onSelectTemplate, onClose }) => {
  return (
    <>
      <DialogHeader
        title="Create New Segment"
        subtitle="Choose a template to get started"
        onClose={onClose}
        showCloseButton
      />
      <TemplateList templates={templates} onSelectTemplate={onSelectTemplate} />
    </>
  );
};
